import { useEffect, useState } from "react";
import { api, SITE_HOST } from "./api";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Reset } from "./pages/Reset";
import { Logo } from "./components/Logo";
import { ThemeToggle } from "./components/ThemeToggle";

type AuthState =
  | { kind: "loading" }
  | { kind: "anon" }
  | { kind: "admin"; email: string; id: string };

function resetTokenFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  if (window.location.pathname !== "/reset") return null;
  const token = new URLSearchParams(window.location.search).get("token");
  return token && token.length > 0 ? token : null;
}

export function App() {
  const [auth, setAuth] = useState<AuthState>({ kind: "loading" });
  const resetToken = resetTokenFromUrl();

  useEffect(() => {
    if (resetToken) {
      setAuth({ kind: "anon" });
      return;
    }
    api
      .me()
      .then((me) => setAuth({ kind: "admin", email: me.email, id: me.id }))
      .catch(() => setAuth({ kind: "anon" }));
  }, [resetToken]);

  let content;
  if (resetToken) {
    content = <Reset token={resetToken} />;
  } else if (auth.kind === "loading") {
    content = (
      <div className="login-shell">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
          <Logo size={48} title={SITE_HOST} />
          <span className="muted">Loading…</span>
        </div>
      </div>
    );
  } else if (auth.kind === "anon") {
    content = (
      <Login
        onLogin={(me) => setAuth({ kind: "admin", email: me.email, id: me.id })}
      />
    );
  } else {
    content = (
      <Dashboard
        meEmail={auth.email}
        meId={auth.id}
        onLogout={() => setAuth({ kind: "anon" })}
      />
    );
  }

  // The dashboard carries the theme switch in its topbar; the floating corner
  // button would sit on top of the per-row action buttons on a phone.
  return (
    <>
      {content}
      {auth.kind !== "admin" && <ThemeToggle />}
    </>
  );
}
